import { BrowserRouter as Router } from "react-router-dom";

import "./styles/base/global.css";

import Navbar from "./components/Navbar/Navbar";
import AppBackground from "./components/AppBackground/AppBackground";
import AppRoutes from "./AppRoutes";
import { AuthProvider, useAuth, resolveOnboardingPath } from "./contexts/AuthContext";
import { LeadProvider } from "./contexts/LeadContext";
import { NotificationsProvider } from "./contexts/NotificationsContext";
import { SignupProvider } from "./contexts/SignupContext";

function AppShell() {
  const { auth } = useAuth();

  // Durante el onboarding (mientras quede un paso pendiente) no se considera
  // al usuario "logueado" en la app: se oculta la Navbar.
  const showNavbar = auth && !resolveOnboardingPath(auth);

  return (
    <SignupProvider>
      {showNavbar ? <AppBackground /> : null}
      {showNavbar ? <Navbar /> : null}
      <AppRoutes />
    </SignupProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <LeadProvider>
        <NotificationsProvider>
          <Router>
            <AppShell />
          </Router>
        </NotificationsProvider>
      </LeadProvider>
    </AuthProvider>
  );
}

export default App;
